var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"img-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.svg")}})])])])])
}]

export { render, staticRenderFns }